import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteSiteModal extends Component {
    handleDelete = async () => {
        const { deleteSite, selectedNode } = this.props;

        const parents = selectedNode.parent.split('/');
        const clientId = parents[parents.length - 1];

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await deleteSite(selectedNode.id, clientId);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            title
        } = this.props;

        return (
            <ConfirmActionModal
                errors={errors}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                open={open}
                title={title}
            >
                <p>
                    Warning: Deleting a Site will also delete all Areas, Equipment, Systems, and Sensors tied to this Site.
                </p>
                <p>
                    {`Are you sure you want to delete Site: ${selectedNode.name}?`}
                </p>
            </ConfirmActionModal>
        );
    }
}

DeleteSiteModal.defaultProps = {
    selectedNode: {}
};

DeleteSiteModal.propTypes = {
    close:        func.isRequired,
    open:         bool.isRequired,
    selectedNode: object,
    title:        string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo:  state.companyInfo,
        errors:       state.messages.errors,
        isLoading:    state.ui.isLoading,
        selectedNode: state.architect.selectedNode
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSiteModal);
